import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GlobalServicesService } from './services/global-services.service';
import { SharedServicesService } from './services/shared-services.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MessageService } from 'primeng/api';
import { LoginService } from './services/login.service';
import { environment } from '../environments/environment';
import { AppService } from './services/app.service';
import { RecaptchaService } from './services/recaptcha.service';
import { safeSetItem } from './utils/safe-storage';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [SharedServicesService, MessageService],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  title = 'webapp-neo-hire';
  headerTitle: string = '';
  secondTitle: string = '';
  route = '';
  applicationPage: boolean = false;
  registrationForm: boolean = false;
  forgotPassword: boolean = false;
  resetPassword: boolean = false;
  formPreview: boolean = false;
  routeListener: any;
  userDetails: any;
  authorized: boolean = false;
  searchItem: string = '';
  candidatePanel: boolean = false;
  companyLogo: string = '';
  favIcon: any;
  verification: boolean = false;
  assessment: boolean = false;
  showCopilot: boolean = false;
  ssoCallback: boolean = false;
  loginPage: boolean = false;
  maintenanceMode: boolean = false;
  isAiInterview: boolean = false;

  flexBasedUi: boolean = false;

  constructor(
    private globalService: GlobalServicesService,
    private router: Router,
    private location: Location,
    private loginService: LoginService,
    private messageService: MessageService,
    private sharedService: SharedServicesService,
    private webTitle: Title,
    private appService: AppService,
    private recaptchaService: RecaptchaService,
    private cdr: ChangeDetectorRef
  ) {
    this.router.events.subscribe(() => {
      let nestedPaths = this.location.path().split('/')
      if (nestedPaths[1] === 'events' && nestedPaths.length === 2) {
        this.searchItem = 'Events';
      }
      else if (nestedPaths[1] === 'candidates' && nestedPaths.length === 2) {
        this.searchItem = 'Candidate';
      }
      else if (nestedPaths[1] === 'roles' && nestedPaths.length === 2) {
        this.searchItem = 'Roles';
      }
      else {
        this.searchItem = '';
      }
      if (this.location.path() != '') {
        this.route = this.location.path();
        this.applicationPage = this.route.split('/')[1] === "application-form" ? true : false;
        this.candidatePanel = this.route.split('?')[0] === "/candidatePanel" ? true : false;
        this.verification = this.route.replace('?', '/').split('/')[1] === "verification" ? true : false;
        this.assessment = this.route.split('/')[1] === "assessment" ? true : false;
        this.forgotPassword = this.route.replace('?', '/').split('/')[1] === "forgotPassword" ? true : false;
        this.resetPassword = this.route.replace('?', '/').split('/')[1] === "reset-password" ? true : false;
        this.registrationForm = this.route.replace('?', '/').split('/')[1] === "registration-form" ? true : false;
        this.formPreview = this.route.split('/')[1] === "form" ? true : false;
        this.ssoCallback = this.route.startsWith('/sso/callback') ? true : false;
        this.loginPage = this.route.startsWith('/login') ? true : false;
        this.isAiInterview = this.route.startsWith('/ai-interview') ? true : false;
        this.updateRecaptchaBadgeVisibility();
      } else {
        this.route = ''
      }
    });

    this.sharedService.changeEmitted$.subscribe(res => {
      this.companyLogo = res;
    })
    this.favIcon = document.querySelector('#favIcon');

    this.appService.makeFlexBasedUi.pipe(takeUntil(this.unsub$)).subscribe((res: boolean) => {
      this.flexBasedUi = res;
      this.cdr.detectChanges();
    })
  }

  ngOnInit(): void {
    this.setupMetadataSubscription();
    this.setupVisibilityChangeListener();

    this.loginService.validToken.subscribe((res: any) => {
      if (res.status === 401) {
        this.messageService.add(res.message);
        setTimeout(() => {
          this.router.navigateByUrl('/login');
        }, 5000)
      }
      if (res.statusMessage === 'loggedOut') {
        this.router.navigateByUrl('/login');
        // window.location.reload();
      }
    })
    this.routeListener = this.router.events.subscribe(() => {
      if (this.location.path() != '') {
        this.route = this.location.path();
        this.applicationPage = this.route.split('/')[1] === "application-form" ? true : false;
        this.ssoCallback = this.route.startsWith('/sso/callback') ? true : false;
        this.loginPage = this.route.startsWith('/login') ? true : false;
      } else {
        this.route = ''
      }
    });
    this.globalService.commonGrowl.subscribe((data: any) => {
      const is_key = Object.keys(data).length;
      if (data && is_key) {
        this.messageService.add(data);
      }
    });
  }
  
  private setupMetadataSubscription(): void {
    this.sharedService.initiateMetadataRequest(() => this.globalService.metadataFastApi())
      .subscribe({ error: () => { } });

    this.sharedService.metadata$.subscribe((companyDetails) => {
      if (companyDetails) {
        this.companyLogo = companyDetails.logo || '';
        this.favIcon.href = companyDetails.fav_icon || '';
        this.webTitle.setTitle(companyDetails.name || "Neo Hire");
        safeSetItem("CompanyDetails", JSON.stringify(companyDetails));
        safeSetItem("companyUUID", companyDetails.uuid);
        this.showCopilot = companyDetails.company_config?.copilot ?? false;
      }
    });
    this.sharedService.maintenanceMode$.subscribe((isMaintenanceMode) => {
      this.maintenanceMode = isMaintenanceMode;
      this.updateRecaptchaBadgeVisibility();
    });

    this.sharedService.metadataError$.subscribe((error) => {
      if (error) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      }
    });
  }


  private updateRecaptchaBadgeVisibility(): void {
    if (this.loginPage && !this.maintenanceMode) {
      this.recaptchaService.showRecaptchaBadge();
    } else {
      this.recaptchaService.hideRecaptchaBadge();
    }
  }

  private setupVisibilityChangeListener(): void {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.updateRecaptchaBadgeVisibility();
      }
    });
  }

  ngOnDestroy() {
    this.routeListener.unsubscribe();
    this.unsub$.next();
    this.unsub$.complete();
  }
}